module.exports = __webpack_public_path__ + "img/9.56f2ffcc.jpg";